
<div class="app-container">


  <div class="cell head">
    <!-- head -->
    <app-header></app-header>
  </div>

  <div class="cell body">
    <!-- body -->
    <router-outlet></router-outlet>
  </div>

</div>
